const linkifyHtml = require('linkifyjs/html')

export function makeLinksClickable (rawInfo) {
    return linkifyHtml(rawInfo || '')
}
